import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M9 5.827l4.793 7.673H4.207L9 5.827zM9 3L1.5 15h15L9 3z" fill="#54585D" /></svg>);